/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ActionAlertDto, ActionRuleDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Alerts
 */
export const getIntelligenceActionCenterProjectProjectId = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<ActionAlertDto[]>({
    url: `/intelligence/action-center/project/${projectId}`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceActionCenterProjectProjectIdInfiniteQueryKey = (
  projectId?: number,
) => {
  return [
    "infinite",
    `/intelligence/action-center/project/${projectId}`,
  ] as const;
};

export const getGetIntelligenceActionCenterProjectProjectIdQueryKey = (
  projectId?: number,
) => {
  return [`/intelligence/action-center/project/${projectId}`] as const;
};

export const getGetIntelligenceActionCenterProjectProjectIdInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
    >,
    TError = void,
  >(
    projectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntelligenceActionCenterProjectProjectIdInfiniteQueryKey(projectId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
    > = ({ signal }) =>
      getIntelligenceActionCenterProjectProjectId(projectId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetIntelligenceActionCenterProjectProjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >;
export type GetIntelligenceActionCenterProjectProjectIdInfiniteQueryError =
  void;

export function useGetIntelligenceActionCenterProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Alerts
 */

export function useGetIntelligenceActionCenterProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceActionCenterProjectProjectIdInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceActionCenterProjectProjectIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceActionCenterProjectProjectIdQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  > = ({ signal }) =>
    getIntelligenceActionCenterProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceActionCenterProjectProjectIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>
  >;
export type GetIntelligenceActionCenterProjectProjectIdQueryError = void;

export function useGetIntelligenceActionCenterProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Alerts
 */

export function useGetIntelligenceActionCenterProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getIntelligenceActionCenterProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceActionCenterProjectProjectIdQueryOptions(
      projectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Rules
 */
export const getIntelligenceActionCenterRules = (signal?: AbortSignal) => {
  return customInstance<ActionRuleDto[]>({
    url: `/intelligence/action-center/rules`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceActionCenterRulesInfiniteQueryKey = () => {
  return ["infinite", `/intelligence/action-center/rules`] as const;
};

export const getGetIntelligenceActionCenterRulesQueryKey = () => {
  return [`/intelligence/action-center/rules`] as const;
};

export const getGetIntelligenceActionCenterRulesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceActionCenterRulesInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  > = ({ signal }) => getIntelligenceActionCenterRules(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceActionCenterRulesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
>;
export type GetIntelligenceActionCenterRulesInfiniteQueryError = void;

export function useGetIntelligenceActionCenterRulesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterRulesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterRulesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Rules
 */

export function useGetIntelligenceActionCenterRulesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceActionCenterRulesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceActionCenterRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntelligenceActionCenterRulesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
  > = ({ signal }) => getIntelligenceActionCenterRules(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceActionCenterRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
>;
export type GetIntelligenceActionCenterRulesQueryError = void;

export function useGetIntelligenceActionCenterRules<
  TData = Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterRules<
  TData = Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceActionCenterRules<
  TData = Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Rules
 */

export function useGetIntelligenceActionCenterRules<
  TData = Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceActionCenterRules>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceActionCenterRulesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
